import script from "./RoomJoin.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomJoin.vue?vue&type=script&setup=true&lang=js"

import "./RoomJoin.vue?vue&type=style&index=0&id=0765170a&lang=scss"

const __exports__ = script;

export default __exports__